import {ReferentielActionTypes} from "../Actions/actionTypes";

const initialState = {
    documents: [],
    folders: [],
    loading: false,
    isUploading: false,
};

const UNCATEGORIZED_KEY = "__uncategorized__"; // ✅ Constante globale

export default function filesReducer(state = initialState, action) {
    switch (action.type) {
        case ReferentielActionTypes.SET_LOADING_REFERENTIEL:
            return {
                ...state,
                isUploading: action.payload,
            };

        case ReferentielActionTypes.SET_DOCUMENT_LOADING:
            return {
                ...state,
                loading: action.payload,
            };

        case ReferentielActionTypes.SET_DOCUMENTS:
            return {
                ...state,
                documents: action.payload,
            };

        case ReferentielActionTypes.SET_FOLDERS:
            // ✅ On prend simplement les folders du backend sans manipulation
            return {
                ...state,
                folders: action.payload || [],
            };

        case ReferentielActionTypes.ADD_DOCUMENT: {
            // ✅ Normaliser le folder du document ajouté
            const folderKey = action.payload.folder?.trim() || UNCATEGORIZED_KEY;

            // ✅ Vérifier si le dossier existe déjà
            const folderExists = state.folders.some((f) => f.key === folderKey);
            const existingDocument = state.documents.some((doc) => doc.id === action.payload.id);

            return {
                ...state,
                documents: existingDocument
                    ? state.documents.map((doc) => doc.id === action.payload.id ? { ...doc, ...action.payload } : doc)
                    : [...state.documents, action.payload],
                folders: folderExists
                    ? state.folders
                    : [
                        ...state.folders,
                        {
                            key: folderKey,
                            title: folderKey,
                        },
                    ],
            };
        }

        default:
            return state;
    }
}
